













import { Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconComplaintState } from "@/enums/falcon/complaints/falcon-complaint-state.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaints filters state form field component
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class ComplaintsFiltersStateFormField extends Vue {
  @Prop() private setComplaintState!: (
    complaintState: FalconComplaintState
  ) => void;
  @Watch("$route", { immediate: true }) private routeUpdated(): void {
    const { complaintState } = this.$route.query;
    if (complaintState) {
      this.complaintState = +complaintState as FalconComplaintState;
    }
  }

  private complaintState: FalconComplaintState = FalconComplaintState.Open;

  complaintStateEnum = FalconComplaintState;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.complaintStateUpdated();
  }

  complaintStateUpdated(): void {
    this.setComplaintState(this.complaintState);
  }
}
